import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadDeductionDeleteAtom = createMutationAtomFactory(
  'trade.loadDeductionDelete',
  (params: { id: string }) => ({
    tradeLoadDeductionDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
